import { FluxStandardAction } from 'redux-promise-middleware';

export const ActionTypes = Object.freeze({
  KickUser: 'KICK_USER',
  SendMessage: 'SEND_MESSAGE',
  Help: 'HELP',
  BadLocation: 'BAD_LOCATION',
  UnknownLocation: 'UNKNOWN_LOCATION',
  ResetLocation: 'RESET_LOCATION',
  Broadcast: 'BROADCAST',
  BroadcastFaculty: 'BROADCAST_FACULTY',
  SetMotd: 'SET_MOTD',
  SetQueueInfo: 'SET_QUEUE_INFO',
  PurgeQueue: 'PURGE_QUEUE',
  LockQueue: 'LOCK_QUEUE',
  UnlockQueue: 'UNLOCK_QUEUE',
  SetShowHelperToAssistants: 'SET_SHOW_HELPER_TO_ASSISTANTS',
  // >>> call-dibs feature (revertible) >>>
  Claim: 'CLAIM',
  // <<< call-dibs feature <<<
});

export const kickUser = (queueName: string, providerId: string): FluxStandardAction => ({
  type: ActionTypes.KickUser,
  payload: { queueName, providerId }
});

export const sendMessage = (queueName: string, providerId: string, message: string): FluxStandardAction => ({
  type: ActionTypes.SendMessage,
  payload: { queueName, providerId, message }
});

export const toggleHelp = (queueName: string, providerId: string, newStatus: boolean): FluxStandardAction => ({
  type: ActionTypes.Help,
  payload: { queueName, providerId, newStatus }
});

// >>> call-dibs feature (revertible) >>>
export const claimUser = (queueName: string, providerId: string, newStatus: boolean): FluxStandardAction => ({
  type: ActionTypes.Claim,
  payload: { queueName, providerId, newStatus }
});
// <<< call-dibs feature <<<

export const badLocation = (queueName: string, providerId: string): FluxStandardAction => ({
  type: ActionTypes.BadLocation,
  payload: { queueName, providerId }
});

export const unknownLocation = (queueName: string, providerId: string): FluxStandardAction => ({
  type: ActionTypes.UnknownLocation,
  payload: { queueName, providerId }
});

export const resetLocation = (queueName: string, providerId: string): FluxStandardAction => ({
  type: ActionTypes.ResetLocation,
  payload: { queueName, providerId }
});

export const broadcast = (queueName: string, message: string): FluxStandardAction => ({
  type: ActionTypes.Broadcast,
  payload: { queueName, message }
});

export const broadcastFaculty = (queueName: string, message: string): FluxStandardAction => ({
  type: ActionTypes.BroadcastFaculty,
  payload: { queueName, message }
});

export const setMotd = (queueName: string, message: string): FluxStandardAction => ({
  type: ActionTypes.SetMotd,
  payload: { queueName, message }
});

export const setQueueInformation = (queueName: string, info: string): FluxStandardAction => ({
  type: ActionTypes.SetQueueInfo,
  payload: { queueName, info }
});

export const purgeQueue = (queueName: string): FluxStandardAction => ({
  type: ActionTypes.PurgeQueue,
  payload: { queueName }
});

export const lockQueue = (queueName: string): FluxStandardAction => ({
  type: ActionTypes.LockQueue,
  payload: { queueName }
});

export const unlockQueue = (queueName: string): FluxStandardAction => ({
  type: ActionTypes.UnlockQueue,
  payload: { queueName }
});

export const setShowHelperToAssistants = (queueName: string, status: boolean): FluxStandardAction => ({
  type: ActionTypes.SetShowHelperToAssistants,
  payload: { queueName, status }
});
